import * as types from "./actions";
import APIUtil from "./../config/APIUtil";
import UrlConstants from "./../config/UrlConstants";
import * as code from "./../config/Constants";

/**
 *
 * @desc Get APP systemBanners
 */

export function getSystemBannersAction(recordPerPage, pageIndex) {
  var url = UrlConstants.getSystemBannersUrl.replace(
    "{recordPerPage}",
    recordPerPage
  );
  var replacedUrl = url.replace("{pageIndex}", pageIndex);
  // if (searchKey) {
  //   replacedUrl = replacedUrl + "&searchKey=" + searchKey;
  // }
  return function(dispatch) {
    return APIUtil.getMethod(replacedUrl, true).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_SYSTEMBANNERS,
          systemBanners: response.data.data,
          totalBanners: response.data.total,
        });
      } else {
        dispatch({
          type: types.GET_SYSTEMBANNERS,
          systemBanners: [],
          totalBanners: null,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get banner details
 */

export function getSystemBannerDetailsAction(id) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.systemBannersUrl + "/getBannerDetails?id=" + id,
      true
    ).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_SYSTEMBANNER_DETAILS,
          systemBannerDetails: response.data,
        });
      } else {
        dispatch({
          type: types.GET_SYSTEMBANNER_DETAILS,
          systemBannerDetails: {},
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Add New APP release
 */

export function addSystemBannersAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.systemBannersUrl + "/addSystemBanner",
      data,
      true
    ).then((response) => {
      if (response) {
        dispatch({
          type: types.ADD_SYSTEMBANNERS,
          systemBanners: response.data,
        });
      } else {
        dispatch({
          type: types.ADD_SYSTEMBANNERS,
          systemBanners: [],
        });
      }
      return response;
    });
  };
}

export function deleteSystemBannersAction(id) {
  return function(dispatch) {
    return APIUtil.deleteMethod(
      UrlConstants.systemBannersUrl + "/" + id,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_SYSTEMBANNERS,
          systemBanners: response.data,
        });
      } else {
        dispatch({
          type: types.GET_SYSTEMBANNERS,
          systemBanners: [],
        });
      }

      return response || [];
    });
  };
}

export function editSystemBannersAction(data, id) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.systemBannersUrl + "/updateSystemBanner?id=" + id,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_SYSTEMBANNERS,
          systemBanners: response.data,
        });
      } else {
        dispatch({
          type: types.GET_SYSTEMBANNERS,
          systemBanners: response.data,
        });
      }

      return response || [];
    });
  };
}

export function updateSystemBannerStatusAction(data) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.systemBannersUrl + "/activeInactive",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_SYSTEMBANNERS,
          systemBanners: response.data,
        });
      } else {
        dispatch({
          type: types.GET_SYSTEMBANNERS,
          systemBanners: response.data,
        });
      }

      return response || [];
    });
  };
}

export function getCurrentSystemBannerAction() {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.systemBannersUrl + "/getCurrentDateBanner",
      true
    ).then((response) => {
      if (response.status === code.OK) {
        return response;
      } else {
        return [];
      }
    });
  };
}
